/**
 * Every level in a Bar Intelligence stack, while the pointer is on its label.
 *
 * The chart draws only the top of a stack — the longest period — so levels at
 * the same price never pile their labels on each other (D8,
 * `docs/plans/bar-intelligence.md`). This is where the rest are read.
 *
 * `position: fixed` and `pointerEvents: none`, `EventPopup`'s reasons: the
 * chart's root clips, and the popup exists because the pointer is elsewhere.
 */

import type { CSSProperties } from "react";

const GAP = 12;
const EDGE = 8;
const ESTIMATED_WIDTH = 420;

export function LevelsPopup({ lines, at }: { lines: readonly string[]; at: { x: number; y: number } }) {
  const vw = typeof window === "undefined" ? 1920 : window.innerWidth;
  // Left of the pointer when there is no room to its right — the labels sit at
  // the right edge of the chart, so that is the usual case.
  const left =
    at.x + GAP + ESTIMATED_WIDTH > vw - EDGE ? Math.max(EDGE, at.x - GAP - ESTIMATED_WIDTH) : at.x + GAP;
  return (
    <div role="tooltip" style={{ ...PANEL, left, top: Math.max(EDGE, at.y + GAP) }}>
      {lines.map((line) => (
        <div key={line} style={ROW}>
          {line}
        </div>
      ))}
    </div>
  );
}

const PANEL: CSSProperties = {
  position: "fixed",
  zIndex: 1000,
  pointerEvents: "none",
  background: "var(--qf-surface)",
  border: "1px solid var(--qf-border)",
  borderRadius: 6,
  boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
  padding: "6px 10px",
  font: "inherit",
  fontSize: 11,
  color: "var(--qf-text)",
  maxWidth: ESTIMATED_WIDTH,
};

const ROW: CSSProperties = {
  whiteSpace: "nowrap",
  fontVariantNumeric: "tabular-nums",
  lineHeight: 1.6,
};
